import React from 'react';
import {SkeletonBlock} from '@aboutyou/ui-components';
import styled from 'styled-components';

export const UnavailableProductsSkeleton = () => {
  return (
    <Wrapper>
      <TitleSkeleton $width="30%" disableSpaceBelow />
      <BasketItemSkeleton />
    </Wrapper>
  );
};

const BasketItemSkeleton = () => {
  return (
    <BasketItemWrapper>
      <BasketItemDetailsThumb>
        <SkeletonBlock $width="100%" $height="160px" disableSpaceBelow />
      </BasketItemDetailsThumb>
      <BasketDetailsColumn>
        <BasketItemDetailsSkeleton>
          <SkeletonBlock $width="40%" $height="20px" />
        </BasketItemDetailsSkeleton>
      </BasketDetailsColumn>
    </BasketItemWrapper>
  );
};

const BasketItemWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
`;

const BasketItemDetailsThumb = styled.div`
  flex-basis: 145px;
`;

const BasketDetailsColumn = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
`;

const BasketItemDetailsSkeleton = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1 1 0;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 1rem 1rem 0;
`;
const TitleSkeleton = styled(SkeletonBlock)`
  height: 1.15rem;
`;
